<template>
  <div id="home">
    <div style="background-color: white; margin: 1rem 2rem;display: flex;">
      <div class="content-left" style="width: auto;">
        <el-menu default-active="1" class="el-menu-vertical-demo" text-color="#000000">
          <el-menu-item index="1" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <span>成本中心</span>
          </el-menu-item>
          <el-menu-item index="2" @click="MenuSelect">
            <i class="el-icon-setting"></i>
            <span>在线付</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="pos_container_panel" v-show="isShow=='1'">
        <!--search area-->
        <el-form :inline="true" :model="searchForm" label-width="150px">
          <el-row style="padding-top: 2rem">
            <el-col :span="10">
              <el-form-item
                label="客户名称："
                style="margin-bottom: 0; margin-left: 1rem"
              >
                <el-input
                  @click="showClientNamePop"
                  readonly
                  v-model="searchForm.client"
                  placeholder="请选择"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label=""
                style="margin-bottom: 0; margin-left: 1rem"
              >
                <el-switch
                  :disabled="isSelect"
                  v-model="dataForm.isopen"
                  active-color="#13ce66"
                  active-text="开启"
                  inactive-text="关闭"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-footer>
                <el-button type="warning" v-if="this.btnshow == 2" @click="saveForm()">保存</el-button>
                <el-button type="warning" v-if="this.btnshow == 2" @click="btnStatus(false)">取消</el-button>
                <el-button type="warning" v-if="this.btnshow == 1" @click="btnStatus(true)">修改</el-button>
              </el-footer>
            </el-col>
          </el-row>
          <el-divider class="title-divider"></el-divider>
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item
                label=""
                style="margin-bottom: 0; margin-left: 16rem"
                prop="username"
              >
                <el-row>
                  <el-col :span="12">
                    <el-radio
                      :disabled="isSelect"
                      v-model="dataForm.isview"
                      label="1"
                      >展示成本中心</el-radio
                    >
                  </el-col>
                  <el-col :span="12" style="padding-left: 10rem">
                    <el-row>
                      <el-col :span="12">
                        <el-radio
                          :disabled="isSelect"
                          v-model="dataForm.isselect"
                          label="1"
                          >预订时自选</el-radio
                        >
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-radio
                        :disabled="isSelect"
                        v-model="dataForm.isselect"
                        label="0"
                        >默认</el-radio
                      >
                    </el-row>
                  </el-col>
                </el-row>
                <el-row>
                  <el-radio
                    :disabled="isSelect"
                    v-model="dataForm.isview"
                    label="0"
                    >不展示成本中心</el-radio
                  >
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider class="title-divider"></el-divider>
          <el-row class="rowtop">
            <el-col :span="12">
              <el-form-item
                label=""
                style="margin-bottom: 0; margin-left: 16rem"
              >
                <el-row>
                  <el-col :span="12">
                    <el-checkbox
                      :disabled="isSelect"
                      v-model="dataForm.isreq"
                      @change="changeReq"
                      >成本中心必填</el-checkbox
                    >
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-checkbox
                      :disabled="isSelect || showIsUatp"
                      v-model="dataForm.isuatp"
                      >是否验证UATP卡</el-checkbox
                    >
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowtop">
            <el-col>
              <el-form-item
                label=""
                style="margin-bottom: 0; margin-left: 16rem"
              >
                <el-row>
                  <el-col :span="12">
                    <el-checkbox
                      :disabled="isSelect || showIsUatp"
                      v-model="dataForm.isQuotaTitle"
                      @change="changeQuotaTitle"
                      >额度不够时提示</el-checkbox
                    >
                  </el-col>
                  <el-col :span="12">
                    <el-input
                      :disabled="isSelect || showIsUatp"
                      v-model="dataForm.quotaTitleCN"
                      maxlength="150"
                      placeholder="请输入中文提示"
                    ></el-input>
                    <el-input
                      :disabled="isSelect || showIsUatp"
                      v-model="dataForm.quotaTitleEN"
                      maxlength="150"
                      placeholder="请输入英文提示"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider class="title-divider"></el-divider>
          <el-row class="rowtop" style="padding-top: 2rem">
            <el-col :span="24">
              <el-form-item
                label="成本中心选取-排序："
                style="margin-bottom: 0; margin-left: 1rem"
              >
                <!-- <el-transfer  v-model="value" :data="data"  :titles="['可选类别', '已选类别']" @right-check-change="choose" target-order="push"> -->
                <el-transfer
                  v-model="choseValue"
                  :data="generateData"
                  :titles="['可选类别', '已选类别']"
                  target-order="push"
                >
                <template #default="{ option }">
                  <div class="default-tranfer-item" @mouseenter="indexKey = option.key" @mouseleave="indexKey = null">
                    <span>{{ option.label }}</span>
                    <div v-show=" choseValue.includes(option.key) &&indexKey === option.key" class="button-group">
                      <!--  阻止事件冒泡  -->
                      <!-- 自定义数据项，将上、下、底部、顶部的排序功能放在数据项里面 -->
                      <el-icon @click.stop.prevent="publicMobileMethod('handleUp', option.key)"><ArrowUp /></el-icon>
                      <el-icon @click.stop.prevent="publicMobileMethod('handleTop', option.key)"><CaretTop /></el-icon>
                      <el-icon @click.stop.prevent="publicMobileMethod('handleDown', option.key)"><ArrowDown /></el-icon>
                      <el-icon @click.stop.prevent="publicMobileMethod('handleBottom', option.key)"><CaretBottom /></el-icon>
                    </div>
                  </div>
                </template>
                </el-transfer>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <HBEOnlinePaymentType v-show="isShow=='2'" ref="onlinePaymentType"></HBEOnlinePaymentType>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <ClientList
      :customerDialogVisible="clientListFlag"
      @setCustomerFlag="setCustomerFlag"
      @customerInfo="selectClient"
    ></ClientList>
  </div>
</template>
  
  <script>
import { searchCostCenter, saveCostCenter } from "@/api/platformData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
import ClientList from "@/components/ClientList.vue";
import HBEOnlinePaymentType from "@/views/HBEConfig/HBEOnlinePaymentType";
import { ArrowUp, CaretTop, ArrowDown, CaretBottom } from '@element-plus/icons-vue'
export default {
  name: "HBECostCenter",
  components: {
    ConfirmBoxs,
    ClientList,
    HBEOnlinePaymentType,
    ArrowUp,
    CaretTop,
    ArrowDown,
    CaretBottom
  },
  provide() {
    return {
      costCenter: this,
    }
  },
  data() {
    return {
      clientListFlag: false,
      searchForm: {
        client: "",
      },
      isSelect: true,
      showIsUatp: true,
      dataForm: {
        isopen: false,
        isview: "1",
        isselect: "1",
        isreq: true,
        isuatp: true,
        selectedtype: "",
        selectedtypename: "",
        isQuotaTitle: 0,
        quotaTitleCN: "",
        quotaTitleEN: "",
      },
      confirmFlag: false,
      confirmMsg: "",
      confirmIcon: "",
      btnshow: 0,
      choseValue: [], // 选中数据
      //item: [], // 右侧勾选数据
      indexKey: null, // 高亮显示
      isShow: '1',
    };
  },
  computed: {
    generateData() {
      const data = [
        { key: 8, label: "入住人默认成本中心", disabled: this.isSelect },
        { key: 9, label: "预定人默认成本中心", disabled: this.isSelect },
        { key: 2, label: "入住人部门", disabled: this.isSelect },
        { key: 4, label: "预订人部门", disabled: this.isSelect },
        { key: 7, label: "他人部门成本中心", disabled: this.isSelect },
        { key: 5, label: "项目成本中心", disabled: this.isSelect },
      ];
      return data;
    },
  },
  methods: {
    //监听右侧选中
    //  choose (value) {
    //   this.item = value
    //  },
    //右侧数据点击排序
    publicMobileMethod(direction, key) {
      const self = this;
      let index;
      // 判断是否超出一条
      //const item = self.item
      // if (item.length === 1 || item.length === 0) {
      if (!this.isSelect) {
        //不可编辑状态下，不可以更改顺序
        self.choseValue.forEach((val, indexs) => {
          // 获取需移动数据的下标
          if (val === key) {
            index = indexs;
          }
        });
        if (
          index === 0 &&
          direction !== "handleBottom" &&
          direction !== "handleDown"
        ) {
          return self.$message("没有上移的空间了");
        }
        if (
          index === self.choseValue.length - 1 &&
          direction !== "handleUp" &&
          direction !== "handleTop"
        ) {
          return self.$message("没有下移的空间了");
        }
        // 改变的数组
        const changeItem = self.choseValue[index];
        // 根据下标在数组中删除该数据
        self.choseValue.splice(index, 1);
        // 判断加入数组位置
        if (direction) {
          // 置顶
          direction === "handleTop" && self.choseValue.unshift(changeItem);
          // 置底
          direction === "handleBottom" && self.choseValue.push(changeItem);
          // 上移
          direction === "handleUp" &&
            self.choseValue.splice(index - 1, 0, changeItem);
          // 下移
          direction === "handleDown" &&
            self.choseValue.splice(index + 1, 0, changeItem);
        }
      }
      // } else {
      //     self.$message.error('只能选择一条数据进行上下移动')
      // }
    },
    closeDialog(form) {
      // console.log(form);
      // this.$refs[form].resetFields();
      form.searchClient = "";
      form.searchClientNo = "";
    },
    // 弹出客户姓名窗口方法
    showClientNamePop() {
      this.clientListFlag = true;
    },
    //选择客户
    selectClient(item) {
      this.hotelCustomerCode = item.customerCode;
      this.searchForm.client = item.customerName;
      this.searchRusult();
      this.isSelect = true;
      this.showIsUatp = true;
      this.btnshow = 1;
      if(this.clientListFlag){
        this.$refs.onlinePaymentType.selectClient(item);
      }
    },
    async searchRusult() {
      let customerParam = {
        params: {
          customerCode: this.hotelCustomerCode,
        },
      };
      await searchCostCenter(customerParam)
        .then((res) => {
          if (res.code == 200) {
            let item = res.data;
            this.choseValue = [];
            if (item) {
              this.dataForm.isopen = item.isopen == 1;
              this.dataForm.isreq = item.isreq == 1;
              this.dataForm.isselect = String(item.isselect);
              this.dataForm.isuatp = item.isuatp == 1;
              this.dataForm.isview = String(item.isview);
              item.selectedtype.split(",").forEach((val) => {
                this.choseValue.push(val - 0);
              });
              this.dataForm.isQuotaTitle = item.isQuotaTitle == 1;
              this.dataForm.quotaTitleCN = String(item.quotaTitleCN);
              this.dataForm.quotaTitleEN = String(item.quotaTitleEN);
              this.showIsUatp = false;
            } else {
              //恢复默认值
              this.showIsUatp = false;
              Object.assign(
                this.$data.dataForm,
                this.$options.data.call(this).dataForm
              );
            }
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "获取失败,请重新选择客户";
            return;
          }
        })
        .catch(function (error) {
          console.log("POS 请求失败", error);
        });
    },
    //confirm
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    btnStatus(val) {
      if (val) {
        this.isSelect = false;
        this.btnshow = 2;
      } else {
        this.isSelect = true;
        this.btnshow = 1;
      }
    },
    saveForm() {
      if (this.dataForm.isQuotaTitle) {
        if (
          this.dataForm.quotaTitleCN == "" ||
          this.dataForm.quotaTitleCN == null ||
          this.dataForm.quotaTitleCN == undefined
        ) {
          return this.$message("请填写额度不足时的中文提示");
        }
        if (
          this.dataForm.quotaTitleEN == "" ||
          this.dataForm.quotaTitleEN == null ||
          this.dataForm.quotaTitleEN == undefined
        ) {
          return this.$message("请填写额度不足时的英文提示");
        }
      }

      let selectedName = [];
      this.choseValue.forEach((val) => {
        this.generateData.forEach((data) => {
          if (data.key == val) selectedName.push(data.label);
        });
      });
      let Param = {
        poscode: this.hotelCustomerCode, //客户名称
        isopen: this.dataForm.isopen ? 1 : 0,
        isview: this.dataForm.isview - 0,
        isselect: this.dataForm.isselect - 0,
        isreq: this.dataForm.isreq ? 1 : 0,
        isuatp: this.dataForm.isuatp ? 1 : 0,
        selectedtype: this.choseValue.join(","),
        selectedtypename: selectedName.join(","),
        isDel: false,
        iSQuotaTitle: this.dataForm.isQuotaTitle ? 1 : 0,
        quotaTitleCN: this.dataForm.quotaTitleCN,
        quotaTitleEN: this.dataForm.quotaTitleEN,
      };

      saveCostCenter(Param)
        .then((res) => {
          console.log("save CostCenter信息", res);
        })
        .catch(function (error) {
          console.log("save CostCenter 请求失败", error.objError);
        });
      this.confirmFlag = true;
      this.confirmMsg = "保存成功";
      this.btnshow = 1;
      this.isSelect = true;
    },
    setCustomerFlag(value) {
      this.clientListFlag = value;
    },
    changeReq() {
      this.showIsUatp = !this.dataForm.isreq;
      this.dataForm.isuatp = !this.dataForm.isreq
        ? false
        : this.dataForm.isuatp;
      this.dataForm.isQuotaTitle = !this.dataForm.isreq
        ? false
        : this.dataForm.isuatp;
    },
    changeQuotaTitle(){

    },
    //菜单选择
    MenuSelect(value) {
      let index = value.index;
      this.isShow=index;
    },
  },
};
</script>
  
  <style scoped>
.pos_container_panel {
  /*padding: 0 16rem 4rem;*/
  padding-bottom: 15rem;
  padding-left: 10rem;
}
.rowtop {
  padding-top: 1rem;
}
.title-divider {
  margin: 1rem 0;
}
.default-tranfer-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.button-group em {
  margin-right: 8px;
  font-weight: bold;
}
::v-deep .el-checkbox {
  margin-right: 0px;
}

::v-deep .el-transfer-panel {
  width: 250px;
}
</style>